import { render, staticRenderFns } from "./AMCarpioG2.vue?vue&type=template&id=1a2025aa&scoped=true"
import script from "./AMCarpioG2.vue?vue&type=script&lang=ts"
export * from "./AMCarpioG2.vue?vue&type=script&lang=ts"
import style0 from "./AMCarpioG2.vue?vue&type=style&index=0&id=1a2025aa&prod&lang=scss&scoped=true"
import style1 from "./AMCarpioG2.vue?vue&type=style&index=1&id=1a2025aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2025aa",
  null
  
)

export default component.exports